/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class SidebarService {
  menuItems;
  private sideSubject = new Subject<any>();
  sideState = this.sideSubject.asObservable();
  adminSideBar = [];
  corpId;
  userDetails;
  accessDetailsList;

}
